module.exports = {"469025100":"牙叉镇","469025101":"七坊镇","469025102":"邦溪镇","469025103":"打安镇","469025200":"细水乡","469025201":"元门乡","469025202":"南开乡","469025203":"阜龙乡","469025204":"青松乡","469025205":"金波乡","469025206":"荣邦乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/469025.json
// module id = 2206
// module chunks = 0